// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vc-message {
  margin: 2rem 0;
  font-family: 'Raleway', sans-serif;
  text-align: center; /* Center-align content for a cleaner vertical look */
  position: relative;
  z-index: 3;
}

.container {
  max-width: 1200px; /* Consistent page width */
  margin: auto;
  padding: 0 15px;
}

.vc-content {
  background-color: #e1e7ec; 
  border-radius: 12px;
  
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

.vc-image {
  /* width: 1000px; Larger image at the top */
  width: 100%;
  height: 500px;
  object-position: 20% 37%;
  border-radius: 0px;
  object-fit: cover;
  margin-top: 10px;
  border: 0px solid rgba(0, 0, 0, 0.2);
  
}

.message-content {
  font-family: 'Raleway', sans-serif;
}

.message-content h2 {
  font-size: 2.2rem; /* Large font size for the title */
  font-weight: 600;
  font-family: 'Raleway', sans-serif;
  color: #142651;
}

.message-content p {
  font-size: 1rem; /* Slightly larger font for better readability */
  line-height: 1.5; /* Improved spacing */
  color: #0a1b2c;
  font-family: 'Raleway', sans-serif;
  text-align: left;
}

.message-content .mt-4 {
  margin-top: 2rem;
  margin-bottom: 1.2rem ;
}

@media (max-width: 768px) {
  .vc-image {
    width: 250px; /* Adjust image size for smaller screens */
  }

  .message-content h2 {
    font-size: 1.4rem;
  }

  .message-content p {
    font-size: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ViceChancellorMessage.css"],"names":[],"mappings":"AAGA;EACE,cAAc;EACd,kCAAkC;EAClC,kBAAkB,EAAE,qDAAqD;EACzE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;;EAEnB,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;;AAEtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB,EAAE,kCAAkC;EACrD,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe,EAAE,gDAAgD;EACjE,gBAAgB,EAAE,qBAAqB;EACvC,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY,EAAE,0CAA0C;EAC1D;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap');\r\n\r\n.vc-message {\r\n  margin: 2rem 0;\r\n  font-family: 'Raleway', sans-serif;\r\n  text-align: center; /* Center-align content for a cleaner vertical look */\r\n  position: relative;\r\n  z-index: 3;\r\n}\r\n\r\n.container {\r\n  max-width: 1200px; /* Consistent page width */\r\n  margin: auto;\r\n  padding: 0 15px;\r\n}\r\n\r\n.vc-content {\r\n  background-color: #e1e7ec; \r\n  border-radius: 12px;\r\n  \r\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.vc-image {\r\n  /* width: 1000px; Larger image at the top */\r\n  width: 100%;\r\n  height: 500px;\r\n  object-position: 20% 37%;\r\n  border-radius: 0px;\r\n  object-fit: cover;\r\n  margin-top: 10px;\r\n  border: 0px solid rgba(0, 0, 0, 0.2);\r\n  \r\n}\r\n\r\n.message-content {\r\n  font-family: 'Raleway', sans-serif;\r\n}\r\n\r\n.message-content h2 {\r\n  font-size: 2.2rem; /* Large font size for the title */\r\n  font-weight: 600;\r\n  font-family: 'Raleway', sans-serif;\r\n  color: #142651;\r\n}\r\n\r\n.message-content p {\r\n  font-size: 1rem; /* Slightly larger font for better readability */\r\n  line-height: 1.5; /* Improved spacing */\r\n  color: #0a1b2c;\r\n  font-family: 'Raleway', sans-serif;\r\n  text-align: left;\r\n}\r\n\r\n.message-content .mt-4 {\r\n  margin-top: 2rem;\r\n  margin-bottom: 1.2rem ;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .vc-image {\r\n    width: 250px; /* Adjust image size for smaller screens */\r\n  }\r\n\r\n  .message-content h2 {\r\n    font-size: 1.4rem;\r\n  }\r\n\r\n  .message-content p {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
